import {
  RATINGCHIEFLIST
} from '../actions/ratingChief';
import {reducerPackage} from "../../utils";

export const ratingChiefList = reducerPackage(RATINGCHIEFLIST);

